/* HOOKSTER redesign - normalise Judge.me's rating badge spacing, site-wide.

   Judge.me renders the badge label as a SINGLE text node reading
   "5.0 |8 Reviews" - space before the pipe, none after. It is one text node,
   so no CSS selector can reach the divider; it has to be rewritten in JS.

   This runs on every page because the badge also appears on collection grids
   and the home best-sellers row, not just the PDP. It replaced a per-template
   copy that only covered product pages.

   Judge.me renders asynchronously and re-renders on paginate/sort, so a plain
   one-shot pass is not enough: this retries on a few timers and watches the
   DOM, debounced, then disconnects so nothing is left observing forever.
   The rewrite is idempotent - it only writes when the value actually changes,
   so it cannot loop against its own mutation. */

(function () {
  var TIMERS = [0, 600, 1800, 4000];
  var WATCH_MS = 15000;

  function normalise() {
    var nodes = document.querySelectorAll('.jdgm-prev-badge__text');
    for (var i = 0; i < nodes.length; i++) {
      var v = nodes[i].textContent;
      if (!v || v.indexOf('|') < 0) continue;
      var next = v.replace(/\s*\|\s*/g, ' | ');
      if (next !== v) nodes[i].textContent = next;
    }
  }

  function boot() {
    for (var i = 0; i < TIMERS.length; i++) setTimeout(normalise, TIMERS[i]);

    if (typeof MutationObserver !== 'function' || !document.body) return;

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        normalise();
      }, 200);
    });

    try {
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, WATCH_MS);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
